import loadTypes from 'utils/loadTypes'
import formatDate from 'date-fns/format'
import * as _ from 'lodash'

export const INCOMMING_TRAFFIC = loadTypes('INCOMMING_TRAFFIC')
export const INCOMMING_TOTAL_TRAFFIC = loadTypes('INCOMMING_TOTAL_TRAFFIC')
export const SESSION_MAPPING_DATA = loadTypes('SESSION_MAPPING_DATA')

function formatItemTime(item) {
  const unitTime = item.hour || item.day || item.week || item.month || item.year
  let unitTimePattern
  if (item.hour) {
    unitTimePattern = 'YYYY-MM-DD HH:mm'
  } else if (item.day) {
    unitTimePattern = 'YYYY-MM-DD'
  } else if (item.week) {
    unitTimePattern = 'YYYY-MM-DD'
  } else if (item.month) {
    unitTimePattern = 'YYYY-MM'
  } else if (item.year) {
    unitTimePattern = 'YYYY'
  }

  const time = formatDate(unitTime, unitTimePattern)
  return time
}

function processMetric(request, response) {
  if (!response) return null
  let regConversionSum = 0
  let ftdConversionSum = 0
  let sessionSum = 0
  let impressionSum = 0
  let sessionMappingRateSum = 0

  const metrics = request.queryParams.metrics || []
  const hasRegConversion = metrics.includes('order:regCount-non-direct-last-click')
  const hasFtdConversion = metrics.includes('order:ftdCount-non-direct-last-click')
  const hasSession = metrics.includes('session:count')
  const hasImpression = metrics.includes('impression:count')
  const hasSessionMappingRate = metrics.includes('session:mappingRate')

  let regConversionMetric = []
  let ftdConversionMetric = []
  let sessionMetric = []
  let impressionMetric = []
  let sessionMappingRateMetric = []
  _.map(response, item => {
    const time = formatItemTime(item)
    if (hasRegConversion) {
      let value = item['order:regCount-non-direct-last-click']
      regConversionSum += value || 0
      regConversionMetric.push({
        time,
        value,
        valueSum: regConversionSum
      })
    }

    if (hasFtdConversion) {
      let value = item['order:ftdCount-non-direct-last-click']
      ftdConversionSum += value || 0
      ftdConversionMetric.push({
        time,
        value,
        valueSum: ftdConversionSum
      })
    }
    if (hasSession) {
      let value = item['session:count']
      sessionSum += value || 0
      sessionMetric.push({
        time,
        value,
        valueSum: sessionSum
      })
    }
    if (hasImpression) {
      let value = item['impression:count']
      impressionSum += value || 0
      impressionMetric.push({
        time,
        value,
        valueSum: impressionSum
      })
    }

    if (hasSessionMappingRate) {
      let value = item['session:mappingRate']
      sessionMappingRateMetric.push({
        time,
        value
      })
    }
  })

  const result = {}

  if (hasRegConversion) {
    result['order:regCount-non-direct-last-click'] = {
      label: 'Registration Finished Conversions',
      format: 'number',
      data: regConversionMetric
    }
  }

  if (hasFtdConversion) {
    result['order:ftdCount-non-direct-last-click'] = {
      label: 'First Time Deposit Conversions',
      format: 'number',
      data: ftdConversionMetric
    }
  }

  if (hasSession) {
    result['session:count'] = {
      label: 'Sessions',
      format: 'number',
      data: sessionMetric
    }
  }

  if (hasImpression) {
    result['impression:count'] = {
      label: 'Impressions',
      format: 'number',
      data: impressionMetric
    }
  }

  if (hasSessionMappingRate) {
    result['session:mappingRate'] = {
      label: '% Of Mapped Sessions',
      format: 'doublePercent',
      data: sessionMappingRateMetric
    }
  }

  return result
}

const initialState = {
  metrics: {},
  isFetching: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case INCOMMING_TRAFFIC.REQUEST:
      return {
        ...state,
        data: [],
        isFetching: true
      }
    case INCOMMING_TRAFFIC.SUCCESS:
      return {
        ...state,
        metrics: {
          ...state.metrics,
          ...processMetric(action.request, action.response)
        },
        isFetching: false
      }
    case INCOMMING_TRAFFIC.FAILURE:
      return {
        ...state,
        metrics: {},
        isFetching: false
      }
    case INCOMMING_TOTAL_TRAFFIC.SUCCESS:
      return {
        ...state,
        total: {...state.total, ...action.response[0]}
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/insights/incomming.js